module.exports = __webpack_public_path__ + "img/download.4aecd20d.svg";